var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledMarketingPlatform(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 15V27C30 27.5625 29.5312 28 29 28C28.4375 28 28 27.5625 28 27V15C28 14.4688 28.4375 14 29 14C29.5312 14 30 14.4688 30 15ZM13.9688 18.9688L27 15V27L22.875 25.7812C22.5625 27.0625 21.375 28 20 28C18.3125 28 17 26.6562 17 25C17 24.6562 17.0312 24.3438 17.1562 24.0312L13.9688 23.0625C13.9688 23.5938 13.5312 24 13 24C12.4375 24 12 23.5625 12 23V19C12 18.4688 12.4375 18 13 18C13.5312 18 13.9688 18.4375 13.9688 18.9688ZM21.4375 25.3438L18.5938 24.4688C18.5312 24.625 18.5 24.8125 18.5 25C18.5 25.8438 19.1562 26.5 20 26.5C20.6875 26.5 21.3125 26 21.4375 25.3438Z",
    fill: "#5F6774"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledMarketingPlatform);
export default __webpack_public_path__ + "static/media/filledMarketingPlatform.f10f979086d33f31fd7d128f386899b9.svg";
export { ForwardRef as ReactComponent };